export const FETCH_CHOOSE_CARRIER_SUCCESS = 'FETCH_CHOOSE_CARRIER_SUCCESS';
export const FETCH_CHOOSE_CARRIER_REQUEST = 'FETCH_CHOOSE_CARRIER_REQUEST';
export const UPDATE_CHOOSE_CARRIER_REQUEST = 'UPDATE_CHOOSE_CARRIER_REQUEST';
export const FETCH_CHOOSE_CARRIER_FAILURE = 'FETCH_CHOOSE_CARRIER_FAILURE';
export const fetchChooseCarrierSuccess = (payload) => ({
    type: FETCH_CHOOSE_CARRIER_SUCCESS,
    payload,
});
export const fetchChooseCarrierRequest = () => ({
    type: FETCH_CHOOSE_CARRIER_REQUEST,
});
export const updateChooseCarrier = (payload) => ({
    type: UPDATE_CHOOSE_CARRIER_REQUEST,
    payload,
});
